import Cookies from 'js-cookie'
import website from '@/config/website'

const tokenKey = website.tokenKey
let inFifteenMinutes = new Date(new Date().getTime() + website.tokenTime * 1000);
export function getToken () {
  return Cookies.get(tokenKey)
}

export function setToken (token) {
  return Cookies.set(tokenKey, token, { expires: inFifteenMinutes })
}

export function removeToken () {
  return Cookies.remove(tokenKey)
}
